<template>
  <q-dialog v-model="open" persistent @hide="$emit('update:isOpen', false)">
    <q-card style="width: 20rem; max-width: 90vw">
      <q-card-section>
        <h6 class="text-center">Add City</h6>
      </q-card-section>

      <q-card-section>
        <q-input
          v-model="name"
          no-error-icon
          label="City name"
          error-message="City name is required"
          :error="$v.name.$error"
        />

        <q-input
          v-model="country"
          no-error-icon
          label="City country"
          error-message="City country is required"
          :error="$v.country.$error"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="muted" label="Cancel" :disable="isLoading" />
        <q-btn color="primary" label="Add" :loading="isLoading" @click="addCity" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import API from '@/apis';
import { getErrorMessage } from '@/utils';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      open: true,
      isLoading: false,
      name: '',
      country: '',
    };
  },

  methods: {
    async addCity() {
      this.$v.$reset();
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.isLoading = true;

        const { data } = await this.$axios.request(API.city.create({ name: this.name, country: this.country }));

        this.$q.notify({ message: 'A new city has been added', type: 'positive' });
        this.$emit('created', data);
        this.open = false;
      } catch (error) {
        this.$q.notify({ message: getErrorMessage(error), type: 'negative' });
      } finally {
        this.isLoading = false;
      }
    },
  },

  validations: {
    name: { required },
    country: { required },
  },
};
</script>
